import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { LicenciadorService } from '../licenciamento/service/licenciador.service';

@Component({
  selector: 'app-auth-callback',
  template: ``,
})
export class AuthCallbackComponent {

  //private router: Router, private http: HttpClient
  constructor(
    private router: Router,
    private authService: AuthService,
    private licenciadorService: LicenciadorService
  ) {
    //const roles: string[] = this.authService.role.replace(/^\[|\]$/g, '').split(',').map((s: string) => s.trim());
    if (this.authService.isNaoLicenciado){
      this.router.navigate(['licenciamento']);
    }else {
      this.router.navigate(['home']);
    }
    
    this.licenciadorService.validarLicenca().subscribe({
      next: (res) => {
        console.log('Sucesso: ' + res);        
      },
      error: (err) => {
        console.log('Erro: ' + err);
      }
    });
   }
   
}
